export const TICKET_TABLE_COLUMN_WIDTHS = {
	select: 44,
	number: 72,
	subject: 320,
	contact: 180,
	account: 220,
	status: 140,
	priority: 140,
	category: 156,
	assignee: 164,
	lastUpdate: 112,
} as const;

export type TicketTableColumnKey = keyof typeof TICKET_TABLE_COLUMN_WIDTHS;

const COLUMNS_WITH_ACCOUNT = [
	'select',
	'number',
	'subject',
	'contact',
	'account',
	'status',
	'priority',
	'category',
	'assignee',
	'lastUpdate',
] as const satisfies readonly TicketTableColumnKey[];

const COLUMNS_WITHOUT_ACCOUNT = [
	'select',
	'number',
	'subject',
	'contact',
	'status',
	'priority',
	'category',
	'assignee',
	'lastUpdate',
] as const satisfies readonly TicketTableColumnKey[];

export const TICKET_TABLE_MIN_WIDTH_WITH_ACCOUNT = Object.values(TICKET_TABLE_COLUMN_WIDTHS).reduce(
	(total, width) => total + width,
	0
);

export const TICKET_TABLE_MIN_WIDTH_WITHOUT_ACCOUNT = COLUMNS_WITHOUT_ACCOUNT.reduce(
	(total, column) => total + TICKET_TABLE_COLUMN_WIDTHS[column],
	0
);

export function getTicketTableColumns(showAccountColumn: boolean): readonly TicketTableColumnKey[] {
	return showAccountColumn ? COLUMNS_WITH_ACCOUNT : COLUMNS_WITHOUT_ACCOUNT;
}
